import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import styles from './prop-item.scss.js';
/**
 * cipublic-prop-item
 *
 * @slot heading
 * @slot content
 * @slot link
 */
export class PropItem extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Color of the Accent bar
         */
        this.color = 'tertiary';
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<div class="heading"><slot name="heading"></slot></div><slot name="content"></slot><slot name="link"></slot>`;
    }
}
__decorate([
    property({ reflect: true })
], PropItem.prototype, "color", void 0);
//# sourceMappingURL=prop-item.js.map